<template>

  <create-invoice-tab v-if="isCityManager" :globalSearch="globalSearch"/>
  <create-invoice-whole v-else :globalSearch="globalSearch"/>

</template>

<script>
import {Constants} from "../../../Constants/Constant";
import CreateInvoiceTab from "./CreateInvoiceTab";
import CreateInvoiceWhole from "./CreateInvoiceWhole";

export default {
  name: "CreateInvoiceWrapper",
  props:['globalSearch'],
  components: {CreateInvoiceWhole, CreateInvoiceTab},
  computed: {
    isCityManager: function(){
      return this.$store.state.userObj.role[0].id === Constants.cityManagerRoleId
    }
  },
}
</script>

<style scoped>

</style>
